import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-nav-logo',
  templateUrl: './nav-logo.component.html',
  styleUrls: ['./nav-logo.component.scss']
})
export class NavLogoComponent implements OnInit {
  @Input() navCollapsed: boolean;
  @Output() onNavCollapse = new EventEmitter();
  public windowWidth: number;
  public LogoClass : string = "fa fa-align-left";

  constructor() {
    this.windowWidth = window.innerWidth;
  } 
 
  ngOnInit() {
  }
 
  navCollapse() {
    if (this.windowWidth >= 992) {
      this.navCollapsed = !this.navCollapsed;

      if( this.navCollapsed)
        this.LogoClass = "fa fa-times";
      else
        this.LogoClass ="fa fa-align-left";

      this.onNavCollapse.emit();
    }
  }

}
